import { Grid, Table, TableBody, TableContainer } from '@mui/material';
import { useState } from 'react';
import AppContainer from 'src/components/appComponents/AppContainer';
import Scrollbar from 'src/components/scrollbar';
import {
  TableHeadCustom,
  TablePaginationCustom,
  TableSkeleton,
  useTable,
} from 'src/components/table';
import { useGetAllPublishJobsQuery } from 'src/graphql';
import PublishJobsTableRow from 'src/sections/PublishJobs/PublishJobsTableRow';
import PublishJobsTableToolbar from 'src/sections/PublishJobs/PublishJobsTableToolbar';
import { Add_Publish_Jobs_TABLE_HEAD } from 'src/utils/tables-headers';

export default function PublishJobsPage() {
  const table = useTable();
  const [search, setSearch] = useState({ subject: '', status: '' });

  const { data, isLoading } = useGetAllPublishJobsQuery({
    offset: table.offset,
    limit: table.rowsPerPage,
  });

  return (
    <AppContainer
      pageTitle="PublishJobs"
      routeLinks={[{ name: 'Help Center' }, { name: 'PublishJobs' }]}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PublishJobsTableToolbar search={search} setSearch={setSearch} />
        </Grid>
        <Grid item xs={12}>
          <TableContainer>
            <Scrollbar>
              <Table>
                <TableHeadCustom headLabel={Add_Publish_Jobs_TABLE_HEAD} />
                <TableBody>
                  {isLoading
                    ? [...Array(table.rowsPerPage)].map((i, index) => (
                        <TableSkeleton key={index} sx={{ height: 80 }} />
                      ))
                    : data?.getAllPublishJobs?.items?.map((row: any) => (
                        <PublishJobsTableRow key={row.id} row={row} />
                      ))}
                </TableBody>
              </Table>
            </Scrollbar>
          </TableContainer>
          {data && (
            <TablePaginationCustom
              count={data?.getAllPublishJobs?.total_count ?? 0}
              page={table.page}
              rowsPerPage={table.rowsPerPage}
              onPageChange={table.onChangePage}
              onRowsPerPageChange={table.onChangeRowsPerPage}
            />
          )}
        </Grid>
      </Grid>
    </AppContainer>
  );
}
